import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LibraryCloudIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M20.23 9.53C20.13 7.94 19.46 6.45 18.33 5.28C17.05 3.97 15.33 3.25 13.51 3.25C10.74 3.25 8.24999 4.98 7.23999 7.51C6.04999 7.51 4.92999 7.97 4.07999 8.82C3.31999 9.58 2.86999 10.55 2.78999 11.61C0.899994 12.39 -0.250006 14.37 0.0499937 16.43C0.369994 18.61 2.34999 20.25 4.64999 20.25H18.3C21.3 20.25 23.8 17.99 23.99 15.11C24.16 12.56 22.6 10.3 20.23 9.53ZM18.3 18.75H4.64999C3.08999 18.75 1.74999 17.66 1.53999 16.21C1.31999 14.68 2.22999 13.28 3.71999 12.87C4.05999 12.78 4.28999 12.47 4.26999 12.12C4.23999 11.27 4.53999 10.47 5.13999 9.88C5.79999 9.22 6.73999 8.91 7.65999 9.04C8.02999 9.09 8.36999 8.86 8.47999 8.51C9.12999 6.3 11.2 4.75 13.51 4.75C14.93 4.75 16.26 5.31 17.26 6.33C18.25 7.35 18.78 8.68 18.75 10.09C18.75 10.45 18.99 10.77 19.34 10.84C21.3 11.26 22.62 13.01 22.49 15.02C22.35 17.11 20.51 18.75 18.3 18.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LibraryCloudIcon.displayName = 'LibraryCloudIcon';
